import {
  Box,
  Divider,
  Fab,
  FormControl,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import "./index.css";
import React, { useRef, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { MessageType, MetaData } from "../Messages/types";
import {
  useFileUploadMutation,
  useStopMessageMutation,
} from "../../../../services/chat";
import { useDispatch, useSelector } from "react-redux";
import { errorToast } from "../../../../utils/toast";
import { useSearchParams } from "react-router-dom";
import { IoMdAttach } from "react-icons/io";
import { MdOutlineAutoAwesome } from "react-icons/md";
import { IoDocumentText } from "react-icons/io5";
import Checkbox from "@mui/material/Checkbox";
import { IoIosClose } from "react-icons/io";
import { tokensCost } from "../../../../utils/functions";
import { tokenApi } from "../../../../services/token";
import { FaStop } from "react-icons/fa";
import keys from "../../../../utils/keys";
import { ReactComponent as CoinSvg } from "../../../../assets/images/coin.svg";

let msgId = 0;
let tempSelectedFiles: any = [];

export default function Textbox(props: {
  messages: any;
  mode: string;
  bgdefault: string;
  setMessages: (val: any) => void;
  setHydrateThread: (val: boolean) => void;
  setCurrentConversationId: (val: string) => void;
  setTotalTokensUsed: (val: number) => void;
  switchLlm: (val: number) => void;
  conversationId: string | null;
  currentConversationId: string | null;
  refetch: () => void;
  ai_llm?: string | undefined;
  generatedSummary?: string | undefined;
  temperature?: number;
  agePercent?: number;
  ageCheckForHydration: (msgs: any) => void;
  enableBuyMoreTokensPrePopup: () => void;
  setSubscriptionProps: (props: any) => void;
  setShowSubscriptionPopup: (val: boolean) => void;
  apisFetching: boolean;
}) {
  const dispatch = useDispatch();
  const [tooltip, setTooltip] = useState(false);
  const [generateImage, setGenerateImage] = useState(false);
  const theme = useTheme();
  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  // const [sendMessage, sendMessageResult] = useSendMessageMutation();
  const [stopMessage, stopMessageResult] = useStopMessageMutation();
  const [fileUpload, fileUploadResult] = useFileUploadMutation();
  const [streaming, setStreaming] = useState(false);
  const [showChatOptions, setShowChatOptions] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const metaData: any = useSelector((state: any) => state.metaData);
  const tokenBalance = metaData.tokenMetadata.tokenBalance;
  const handleMsgType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
    if (e.target.value == "/") {
      setShowChatOptions(true);
    } else {
      setShowChatOptions(false);
    }
  };

  React.useEffect(() => {
    if (props.generatedSummary) {
      handleEnter(props.generatedSummary);
    }
  }, [props.generatedSummary]);

  const actionsCost = () => {
    const {
      tokenMetadata: { actionsTokensCost },
    } = metaData;
    if (generateImage && !selectedFiles.length) {
      return actionsTokensCost.generate_image + actionsTokensCost.send_message;
    } else if (generateImage && selectedFiles.length) {
      return (
        actionsTokensCost.generate_image +
        actionsTokensCost.upload_attachment +
        actionsTokensCost.send_message
      );
    } else if (!generateImage && selectedFiles.length) {
      return (
        actionsTokensCost.upload_attachment + actionsTokensCost.send_message
      );
    } else {
      return actionsTokensCost.send_message;
    }
  };

  function isValidJSON(str: string): boolean {
    try {
      const parsed = JSON.parse(str);
      return typeof parsed === "object" && parsed !== null;
    } catch (e) {
      return false;
    }
  }

  const handleChatStreamFailed = (err: any, msg: any) => {
    props.setHydrateThread(false);
    if (typeof err == "string") {
      errorToast(err);
      return;
    }
    if (err.name === "AbortError") {
      errorToast("Generation stopped");
    } else {
      tempSelectedFiles = [];
      errorToast(
        err.message || (err.data && err.data.message) || "Unknown error"
      );
      if (
        (err.message || (err.data && err.data.message)).includes(
          "DeepSeek is temporarily unavailable"
        )
      ) {
        props.switchLlm(1);
      }
      const botMsg = document.getElementById(
        "msgid-" + msg[msg.length - 1].message_id
      );
      msg.splice(msg.length - 1, 1);
      props.setMessages(msg);
      if (botMsg) {
        botMsg.remove();
      }
      setGenerateImage(false);
    }
  };

  async function stopStreaming() {
    const response: any = await stopMessage(
      metaData.userInfo["cognito:username"]
    );
    if (response.error) {
      errorToast(
        response.error.error ||
          (response.error.data && response.error.data.message)
      );
    }
  }

  const handleEnter = async (
    e: React.KeyboardEvent<HTMLDivElement> | string | null
  ) => {
    const keyboardEvent = e as React.KeyboardEvent<HTMLDivElement>;
    if (
      (keyboardEvent && keyboardEvent.keyCode == 13) ||
      !e ||
      !keyboardEvent.keyCode
    ) {
      if (tokenBalance < 5) {
        props.setShowSubscriptionPopup(true);
        props.setSubscriptionProps({
          title: "Not enough tokens",
          content: "You don't have enough tokens to complete this action",
          icon: <CoinSvg width={"41px"} height={"41px"} />,
          bgimage: false,
          btn1: "Buy more",
          airhorn: false,
          btncolor: "#218F54",
          handleBtn1: () => props.enableBuyMoreTokensPrePopup(),
          height: "auto",
          width: "760px",
          cancel: () => props.setShowSubscriptionPopup(false),
          cancelText: "Later",
          subContent: "",
        });
        return;
      }
      let files: MetaData[] = [];
      if (selectedFiles.length) {
        try {
          const responses = await Promise.all(
            selectedFiles.map(async (file: any) => {
              const formData = new FormData();
              formData.append("file", file);
              return await fileUpload(formData).unwrap();
            })
          );
          if (responses && responses.length) {
            responses.forEach((res) => {
              files.push({ fileName: res.fileName, fileUrl: res.fileUrl });
            });
          }
        } catch (error) {
          errorToast("Error uploading file");
        }
      }
      setSelectedFiles([]);
      let newMessages = [
        ...props.messages,
        {
          messageContent: message ? message : typeof e == "string" ? e : "",
          role: "user",
          messageTimestamp: new Date().toISOString(),
          contentMetaData: files.map((file: any) => {
            return { fileName: file.fileName.slice(37), fileUrl: file.fileUrl };
          }),
          conversationId:
            props.conversationId || props.currentConversationId || "",
          messageType: files.length ? "file" : "text",
          message_id: msgId + 1,
        },
      ];
      msgId++;
      props.setMessages([
        ...props.messages,
        {
          messageContent: message ? message : typeof e == "string" ? e : "",
          role: "user",
          messageTimestamp: new Date().toISOString(),
          contentMetaData: files.map((file: any) => {
            return { fileName: file.fileName.slice(37), fileUrl: file.fileUrl };
          }),
          conversationId:
            props.conversationId || props.currentConversationId || "",
          messageType: files.length ? "file" : "text",
          message_id: msgId,
        },
      ]);
      setMessage("");
      let newBotMsg = [
        ...newMessages,
        {
          role: "assistant",
          messageContent: "",
          messageTimestamp: new Date().toISOString(),
          contentMetaData: [],
          conversationId:
            props.conversationId || props.currentConversationId || "",
          messageType: "text",
          message_id: msgId + 1,
        },
      ];
      props.setMessages(newBotMsg);
      msgId++;
      setStreaming(true);
      const body: any = {
        message:
          `${generateImage ? "HiiBoGenerateAnImage " : ""}` + (message || e),
        conversationId:
          props.conversationId ||
          props.currentConversationId ||
          searchParams.get("conversation_id") ||
          "",
        user_id: metaData.userInfo["cognito:username"],
        ai_llm: props.ai_llm || "openai",
        fileNames: files.length ? files.map((file) => file.fileName) : [],
        temperature: props.temperature || 0.7,
        stream: true,
      };

      try {
        const streamedResponse: any = await fetch(
          `${keys.baseUrl}hiiboai/chatstream`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          }
        );
        if (streamedResponse.status == 200 || streamedResponse.status == 201) {
          const reader = streamedResponse.body?.getReader();
          const decoder = new TextDecoder();
          let streamBuffer = "";
          let buffer = "";
          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            setGenerateImage(false);
            tempSelectedFiles = [];
            props.setHydrateThread(false);
            const chunk: any = decoder.decode(value, { stream: true });
            if (isValidJSON(chunk)) {
              const jsonResponse = JSON.parse(chunk);
              let msgs: any = JSON.parse(JSON.stringify(newBotMsg));
              if (msgs.find((msg: MessageType) => msg.message_id == msgId)) {
                let _msg = msgs.find(
                  (msg: MessageType) => msg.message_id == msgId
                );
                _msg.messageContent =
                  jsonResponse.fileUrl || jsonResponse.message || "";
                _msg.messageType = generateImage
                  ? jsonResponse.type == "error"
                    ? "error"
                    : "image"
                  : "text";
              }
              setStreaming(false);
              setTimeout(() => {
                document.getElementById("chat-message")?.focus();
              }, 1000);
              props.setMessages(msgs);
              props.refetch();
              const chatDiv: HTMLElement | null =
                document.getElementById("chat");
              if (chatDiv) {
                chatDiv.scrollTo(0, chatDiv.scrollHeight);
              }
              dispatch(tokenApi.util.invalidateTags(["tokenBalance"]));
              setSearchParams({
                conversation_id: jsonResponse.conversationId,
              });
              props.setCurrentConversationId(jsonResponse.conversationId);
              if (jsonResponse.totalTokensUsed) {
                props.setTotalTokensUsed(jsonResponse.totalTokensUsed);
                props.ageCheckForHydration(jsonResponse.totalTokensUsed);
              }
            } else {
              buffer += chunk;

              // Handle multiple parts per chunk
              const lines = buffer.split("data: ");
              buffer = lines.pop() ?? ""; // Save incomplete line
              let msgs: any = JSON.parse(JSON.stringify(newBotMsg));
              lines.forEach((part) => {
                try {
                  const response = part
                    .replace(/(?<!\n)\n\n(?!\n)/g, "")
                    .replace(/\n\n\n/g, "\n");
                  const msgObj = buffer.replaceAll("\n", "");
                  if (response) {
                    if (!response.includes("[DONE]")) {
                      if (msgs.find((msg: any) => msg.message_id == msgId)) {
                        props.setMessages((prev: any) => {
                          const updated = [...prev];
                          const lastIndex = updated.length - 1;
                          updated[lastIndex] = {
                            ...updated[lastIndex],
                            messageContent:
                              updated[lastIndex].messageContent + response,
                          };
                          return updated;
                        });
                      }
                    } else {
                      if (isValidJSON(msgObj)) {
                        setStreaming(false);
                        setTimeout(() => {
                          document.getElementById("chat-message")?.focus();
                        }, 1000);
                        const jsonResponse = JSON.parse(msgObj);
                        props.refetch();
                        const chatDiv: HTMLElement | null =
                          document.getElementById("chat");
                        if (chatDiv) {
                          chatDiv.scrollTo(0, chatDiv.scrollHeight);
                        }
                        dispatch(
                          tokenApi.util.invalidateTags(["tokenBalance"])
                        );
                        setSearchParams({
                          conversation_id: jsonResponse.conversationId,
                        });
                        props.setCurrentConversationId(
                          jsonResponse.conversationId
                        );
                        if (jsonResponse.totalTokensUsed) {
                          props.setTotalTokensUsed(
                            jsonResponse.totalTokensUsed
                          );
                          props.ageCheckForHydration(
                            jsonResponse.totalTokensUsed
                          );
                        }
                      }
                    }
                  }
                } catch (err) {
                  console.log({ err });
                }
              });
            }
          }
        } else {
          setStreaming(false);
          setTimeout(() => {
            document.getElementById("chat-message")?.focus();
          }, 1000);
          handleChatStreamFailed(streamedResponse.statusText, newBotMsg);
        }
      } catch (err: any) {
        setStreaming(false);
        setTimeout(() => {
          document.getElementById("chat-message")?.focus();
        }, 1000);
        console.log({ err });
        handleChatStreamFailed(err, newBotMsg);
      }
    }
  };

  const chatTextBox = () => {
    return (
      <TextField
        variant="standard"
        placeholder="Ask me anything..."
        fullWidth
        onMouseEnter={() =>
          props.agePercent && props.agePercent >= 90
            ? setTooltip(true)
            : setTooltip(false)
        }
        id="chat-message"
        InputProps={{
          disableUnderline: true,
          sx: { color: theme.palette.primary.main, paddingX: 2 },
        }}
        value={message}
        // defaultValue={message}
        multiline
        onChange={handleMsgType}
        onKeyUp={(e) => {
          if (!e.shiftKey && message) {
            handleEnter(e);
          }
        }}
        disabled={
          (props.agePercent && props.agePercent >= 90) ||
          streaming ||
          props.apisFetching
            ? true
            : false
        }
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault(); // Stop new line
            return false; // Ensures event is fully blocked
          }
        }}
        sx={{
          flex: 1,
          backgroundColor: theme.palette.background.default,
          height: "100%",
          borderRadius: "10px",
          "& .MuiInputBase-input": {
            color: theme.palette.primary.main,
            wordWrap: "break-word",
            overflowWrap: "break-word",
            wordBreak: "break-word",
          },
          "& .MuiInputBase-root": {
            width: "100%",
            height: "100%",
            top: selectedFiles.length ? "40px" : "0px",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            wordBreak: "break-word",
          },
          "& input::placeholder": {
            color: "#2a945f",
          },
          "& textarea": {
            height: selectedFiles.length ? "24% !important" : "60% !important",
            marginTop: selectedFiles.length
              ? "-72px !important"
              : "-40px !important",
            overflow: "auto !important",
          },
        }}
      />
    );
  };

  const removeAttachment = (i: number) => {
    const tempSelectedFiles = [...selectedFiles];
    tempSelectedFiles.splice(i, 1);
    setSelectedFiles(tempSelectedFiles);
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files.length > 0) {
      selectFiles(event.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.preventDefault(); // Necessary to allow dropping
    event.dataTransfer.dropEffect = "copy";
  };

  function getExtension(filename: string) {
    return filename.split(".").pop();
  }

  const selectFiles = (file: any) => {
    const ext = getExtension(file.name);
    if (
      ext == "docx" ||
      ext == "c" ||
      ext == "cp" ||
      ext == "cs" ||
      ext == "css" ||
      ext == "doc" ||
      ext == "go" ||
      ext == "html" ||
      ext == "java" ||
      ext == "js" ||
      ext == "json" ||
      ext == "md" ||
      ext == "pdf" ||
      ext == "php" ||
      ext == "pptx" ||
      ext == "py" ||
      ext == "rb" ||
      ext == "sh" ||
      ext == "tex" ||
      ext == "ts" ||
      ext == "txt"
    ) {
      tempSelectedFiles = [...[...selectedFiles, file]];
      setSelectedFiles([...selectedFiles, file]);
    } else {
      errorToast("Invalid file type");
    }
  };

  return (
    <>
      <div className="chat-textbox">
        <FormControl variant="standard" fullWidth sx={{ position: "relative" }}>
          {showChatOptions ? (
            <div className="options">
              <div
                className="chat-option"
                style={{
                  borderTopRightRadius: "8px",
                  borderTopLeftRadius: "8px",
                }}
              >
                Create Ticket
              </div>
              <div className="chat-option">Send Email</div>
            </div>
          ) : null}

          <Box
            sx={{ position: "relative", width: "100%", overflowX: "hidden" }}
          >
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "0px",
                borderRadius: "10px",
                backgroundColor: theme.palette.background.default, // Dark green background
                border: "1px solid #2a945f",
                width: "100%",
                height: "150px",
                backgroundImage: "inherit",
                borderTopLeftRadius: showChatOptions ? "0px" : "10px",
                borderTopRightRadius: showChatOptions ? "0px" : "10px",
              }}
            >
              <Divider
                sx={{
                  margin: "20px 10px 10px 10px",
                  backgroundColor: "#2a945f4d",
                  position: "absolute",
                  zIndex: "99999",
                  width: "97%",
                  bottom: "40px",
                }}
              />
              <div
                style={{ height: "100%", width: "95%" }}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                {tooltip ? (
                  <Tooltip title="This chat requires hydration">
                    {chatTextBox()}
                  </Tooltip>
                ) : (
                  chatTextBox()
                )}
                <input
                  type="file"
                  name="chat_file"
                  id="chat-file"
                  onChange={(e) => {
                    if (e.target && e.target.files) {
                      selectFiles(e.target.files[0]);
                    }
                  }}
                />
              </div>
              <div className="attachments">
                {selectedFiles.map((file: any, i: number) => {
                  return (
                    <div className="attachment">
                      <div style={{ textAlign: "center" }}>
                        <IoDocumentText
                          style={{ width: "25px", height: "25px" }}
                        />
                        <div className="filename">{file.name}</div>
                      </div>
                      <div
                        className="remove-file"
                        onClick={() => removeAttachment(i)}
                      >
                        <IoIosClose />
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="textbox-btns">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    border: "1px solid #2a945f",
                    padding: "4px",
                    paddingRight: "5px",
                    borderRadius: "20px",
                  }}
                  onClick={() => {
                    document.getElementById("chat-file")?.click();
                  }}
                >
                  <IoMdAttach style={{ color: "#2a945f", fontSize: "18px" }} />{" "}
                  <span style={{ color: "#2a945f", fontSize: "13px" }}>
                    Attach file
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    marginLeft: "-3px",
                  }}
                >
                  <Checkbox
                    style={{ color: "#2a945f", padding: "5px" }}
                    size="small"
                    onChange={(e) => {
                      setGenerateImage(e.target.checked);
                    }}
                    checked={generateImage}
                  />
                  <span style={{ color: "#2a945f", fontSize: "13px" }}>
                    Generate image
                  </span>
                </div>
                {metaData.tokenMetadata &&
                metaData.tokenMetadata.actionsTokensCost ? (
                  <div className="token-cost">
                    {tokensCost(actionsCost(), {
                      fontSize: "12px",
                      width: 23,
                      height: 23,
                    })}
                  </div>
                ) : null}
              </div>
            </Paper>

            <Fab
              color="success"
              size="small"
              sx={{
                position: "absolute",
                right: "10px",
                top: "-11px",
                bottom: "50%",
                transform: "translateY(50%)",

                backgroundColor: "#2a945f",
              }}
              onClick={() =>
                streaming ? stopStreaming() : message ? handleEnter(null) : null
              }
            >
              {streaming ? (
                <FaStop style={{ fontSize: "20px", margin: 10 }} />
              ) : (
                <MdOutlineAutoAwesome size={20} />
              )}
            </Fab>
          </Box>
        </FormControl>
      </div>
    </>
  );
}
